import Select1, { Select1Props } from './Select1';
import Select2, { Select2Props, DefaultOptionProps } from './Select2';

export type SelectProps<
  Data extends object | DefaultOptionProps = Record<string, never>,
  // Data2 extends DefaultOptionProps = Record<string, never>,
> =
  | ({
      version?: '1';
    } & Select1Props<Data>)
  | ({
      version: '2';
    } & Select2Props<Data>);

function Select<Data extends object | DefaultOptionProps = Record<string, never>>(props: SelectProps<Data>) {
  const { version } = props;

  if (version === '2') {
    return <Select2 {...props} />;
  }

  return <Select1 {...props} />;
}

export default Select;
